<header class="header">
    <div class="header-grp">
        <div class="icon" (click)="goBackToPrevPage()">
            <i class="ti ti-chevron-left"></i>
        </div>
        <div class="title">
            <h3>ગામ</h3>
        </div>
    </div>
</header>
<main>
    <div class="city-search">
        <div class="filtering">
            <form>
                <input type="search" class="form-control" #filter (keyup)="searchMember($event)"
                    placeholder="શોધો.." />
                <i class="ti ti-search"></i>
            </form>
        </div>
    </div>    
    <mat-tab-group mat-stretch-tabs="true" mat-align-tabs="center">
        <mat-tab label="સભ્યો">
            <div class="main-members family-tabs">
                <a *ngFor="let member of VillageList" class="member-list-item">
                    <ng-container [ngSwitch]="member.image !== ''">
                        <img *ngSwitchCase="true" [src]="baseUrl + member.image" />
                        <img *ngSwitchCase="false" src="../../../assets/img/user_.jpg" />
                    </ng-container>
                    <div (click)="MemberDetails(member.user_id)">
                        <h5>{{ member.name }}</h5>
                        <p>{{ member.contact_no }} | {{ member.gender }}</p>
                    </div>
                </a>
            </div>
        </mat-tab>
    </mat-tab-group>
</main>